import { render } from "./azureDisk.vue?vue&type=template&id=b5ed2cdc"
import script from "./azureDisk.vue?vue&type=script&lang=js"
export * from "./azureDisk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__